import { render, staticRenderFns } from "./ModBillingPage.vue?vue&type=template&id=86d5ff0a&"
import script from "./ModBillingPage.vue?vue&type=script&lang=babel&"
export * from "./ModBillingPage.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports